import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router";
import App from "./App";
import { initSentry } from "./lib/sentry";
import { initializeSettings } from "./lib/stores/settings";
import { initializeThemeEditor } from "./lib/stores/theme-editor";
import { initI18n } from "@vizi/localization";
initI18n(); // Initialize i18n for web
import "./index.css";

// Initialize Sentry FIRST before any other code
initSentry();

// Initialize settings (theme, style variation) before render to prevent flash
initializeSettings();

// Initialize theme editor to apply persisted theme (colors, radius) to document
initializeThemeEditor();

// Detect if running in Electron (file:// protocol doesn't support BrowserRouter)
const isElectron = window.location.protocol === "file:";

// Use HashRouter for Electron (file:// protocol), BrowserRouter for web
const Router = isElectron ? HashRouter : BrowserRouter;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
);
